import { render } from "./Auth.vue?vue&type=template&id=65a3a2f4&scoped=true&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=65a3a2f4&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a3a2f4"]])

export default __exports__